import script from "./InsightsOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./InsightsOverview.vue?vue&type=script&setup=true&lang=js"

import "./InsightsOverview.vue?vue&type=style&index=0&id=b4f4b840&lang=scss&scoped=true"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4f4b840"]])

export default __exports__